/** Ein Ereignis während /me erhält einen weiteren Durchlauf; alte Sitzungen werden verworfen. */
export function createAuthorizationRefresh(refresh: () => Promise<void>, cancelReads: () => Promise<void>, resetQueries: () => Promise<void>) {
  let active = true;
  let pending = false;
  let running: Promise<void> | undefined;
  return {
    dispose: () => { active = false; },
    request: (): Promise<void> => {
      if (!active) return Promise.resolve();
      pending = true;
      if (running) return running;
      running = (async () => {
        while (active && pending) {
          pending = false;
          await cancelReads();
          if (!active) return;
          await refresh();
          if (!active) return;
          await resetQueries();
        }
      })().finally(() => { running = undefined; });
      return running;
    }
  };
}
